module.exports = __webpack_public_path__ + "img/logo_carrier_LGA_90x67.29557b31.svg";